"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CharterStatus;
(function (CharterStatus) {
    CharterStatus["needsApproval"] = "Needs approval";
    CharterStatus["pendingOffers"] = "Pending offers";
    CharterStatus["approvedPending"] = "Approved\u2014pending";
    CharterStatus["booked"] = "Booked";
    CharterStatus["cancelledByAdmin"] = "Cancelled by Admin";
    CharterStatus["cancelledByOwner"] = "Cancelled by Owner";
    CharterStatus["cancelledByRenter"] = "Cancelled by Renter";
    CharterStatus["cancelled"] = "Cancelled";
    CharterStatus["completed"] = "Completed";
})(CharterStatus = exports.CharterStatus || (exports.CharterStatus = {}));
